import React from "react";

export const feesSectionTableHeaderData = (isDarkMode = false) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 300,
    headerName: "Fee Type",
    field: "feeType",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "feeType",
    isDefaultFilterColumn: true,
    fieldKey: "feeType",
    formFieldTitle: "Fee Type",
    disableColumnMenu: true,
    searchKey: "feeType",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
          }}
        >
          {item?.row?.feeType || "N/A"}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 300,
    headerName: "Amount",
    field: "amount",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "amount",
    isDefaultFilterColumn: true,
    fieldKey: "amount",
    formFieldTitle: "Amount",
    disableColumnMenu: true,
    searchKey: "amount",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.feeAmount !== undefined && item?.row?.feeAmount !== null
            ? item?.row?.isFixed
              ? item?.row?.feeAmount
              : `${item?.row?.feeAmount}%`
            : "N/A"}
        </label>
      );
    },
  },
];
